/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CommonErrorDef } from './commonErrorDef';


export interface NotificationValidationResponse { 
    valid?: boolean;
    errors?: Array<CommonErrorDef>;
}

